/**
 * @generated SignedSource<<796fc33759cf26d05abcfe3a5f32f890>>
 * @relayHash 6694db0d583ded133fe329ebcb6935ed
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6694db0d583ded133fe329ebcb6935ed

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type GetAvailableSlotsCapacityInput = {
  agentUserNameOrGender?: FilterByAgentUserNameOrGenderInput | null;
  appointmentType: AppointmentType;
  channel: CommunicationChannel;
  dateInput?: FilterByDateInput | null;
  language: Language;
  licensedInCountry: Country;
  rescheduledAppointmentId?: string | null;
  service: Service;
  specialty: ServiceSpecialty;
};
export type FilterByAgentUserNameOrGenderInput = {
  agentGender: Gender;
  agentUserName?: never;
} | {
  agentGender?: never;
  agentUserName: string;
};
export type FilterByDateInput = {
  from: DateAndSlotInput;
  to: DateAndSlotInput;
};
export type DateAndSlotInput = {
  date: any;
  slotId: number;
};
export type useAvailableSlotsCapacityQuery$variables = {
  input: GetAvailableSlotsCapacityInput;
};
export type useAvailableSlotsCapacityQuery$data = {
  readonly availableSlotsCapacity: {
    readonly error?: {
      readonly message: string;
    };
    readonly isSuccess?: boolean;
    readonly result?: ReadonlyArray<{
      readonly allowPriorityBooking: boolean;
      readonly date: any;
      readonly isAvailable: boolean;
      readonly slotId: number;
    }>;
  };
};
export type useAvailableSlotsCapacityQuery = {
  response: useAvailableSlotsCapacityQuery$data;
  variables: useAvailableSlotsCapacityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSuccess",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SlotCapacity",
      "kind": "LinkedField",
      "name": "result",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slotId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAvailable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowPriorityBooking",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SuccessSlotCapacityResult",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SlotCapacityError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "ErrorSlotCapacityResult",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAvailableSlotsCapacityQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "availableSlotsCapacity",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAvailableSlotsCapacityQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "availableSlotsCapacity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "6694db0d583ded133fe329ebcb6935ed",
    "metadata": {},
    "name": "useAvailableSlotsCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "758d2f6efbdd4b871a3db2df516b92ce";

export default node;
